module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-xpc-backtop rt-xpc-backtop-transition"
  }, [_c('rt-tooltip', {
    attrs: {
      "disabled": !_vm.tooltip,
      "content": _vm.tooltip,
      "effect": "dark",
      "placement": "left"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.viewTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "rt-xpc-backtop-content",
    class: _vm.backtopClasses,
    style: ({
      bottom: _vm.styleBottom,
      right: _vm.styleRight
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments)
      }
    }
  }, [(_vm.shape === 'square' && _vm.type === 'text') ? _c('span', {
    staticClass: "rt-xpc-backtop-color",
    class: _vm.colorClasses
  }, [_vm._v(_vm._s(_vm.text))]) : _c('rt-icon', {
    staticClass: "rt-xpc-backtop-color",
    class: _vm.colorClasses,
    attrs: {
      "name": _vm.icon,
      "color": _vm.computedIconColor,
      "size": "24"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3521aa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/backtop/rtBacktop.vue
// module id = 2216
// module chunks = 137